import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/admin/dashboard'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },

}
